import React from 'react';

import { CardContainer, Column, RadioColumn, Row, Subtitle, Title } from './styles';
import Radio from '../../../../components/Radio';
import { UnitFilter } from '../../../../models/Specialist';

interface UnitCardProps {
  unit: UnitFilter;
  isChecked: boolean;
  onUnitSelected: (location: UnitFilter) => void;
  showRadio?: boolean;
}

export const UnitCard: React.FC<UnitCardProps> = ({ unit, isChecked, onUnitSelected, showRadio }) => {
  return (
    <CardContainer
      onClick={() => {
        if (unit?.active !== false) onUnitSelected(unit);
      }}
    >
      <Column active={unit.active}>
        <Row>
          <Column>
            <Title>{unit.unit_name}</Title>
            <Subtitle>{unit.unit_address}</Subtitle>
          </Column>
          <RadioColumn>{showRadio && <Radio id={unit.unit_id} isChecked={isChecked || false} />}</RadioColumn>
        </Row>
      </Column>
    </CardContainer>
  );
};
